exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".farm-list-management-page[data-v-3a535171] {\n  width: 100%;\n  height: 100%;\n}", ""]);

// exports
